import { render } from "./StateTag.vue?vue&type=template&id=c6402c0c&ts=true"
import script from "./StateTag.vue?vue&type=script&lang=ts"
export * from "./StateTag.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__